import React from 'react';
import { cn } from '../lib/utils';

/**
 * Logo E-CARBU. `size` est la HAUTEUR en pixels (la marque est plus haute
 * que large). Fond transparent ; en mode sombre on affiche la version au
 * bleu éclairci pour rester lisible sur les surfaces foncées.
 */
const Marque = ({ hauteur, className = '' }) => (
  <>
    <img
      src="/brand/logo-mark.png"
      alt="E-CARBU"
      className={cn('block w-auto shrink-0 object-contain dark:hidden', className)}
      style={{ height: `${hauteur}px` }}
    />
    <img
      src="/brand/logo-mark-sombre.png"
      alt="E-CARBU"
      className={cn('hidden w-auto shrink-0 object-contain dark:block', className)}
      style={{ height: `${hauteur}px` }}
    />
  </>
);

const BrandLogo = ({ size = 64, variant = 'hero', className = '' }) => {
  if (variant === 'hero') {
    return (
      <div
        className={cn(
          'flex items-center justify-center rounded-full border border-border bg-card shadow-sm',
          className,
        )}
        style={{ width: `${size}px`, height: `${size}px` }}
      >
        <Marque hauteur={Math.round(size * 0.62)} />
      </div>
    );
  }

  return <Marque hauteur={size} className={className} />;
};

export default BrandLogo;
